import React, { Component } from 'react';
import dayjs from 'dayjs';
import services from '@C/Director/Users/_utils/data';
import { TableGrid } from '@C/TableGrid';
import { CountryList, OMCList } from '@C/Utils';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dealerList: [],
      start_date: dayjs().format('YYYY-MM-DD'),
      loading: true,
      account_id: '',
      business_name: '',
      omc_id: '',
      owner_name: '',
      email: '',
      contact: '',
      country: '',
      state: '',
      city: '',
      area_code: '',
      lead_source: '',
      limit: 20,
      offset: 1,
      count: 0,
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getDealersList();
  }

  getDealersList = () => {
    services
      .getDealersList(this.state)
      .then((response) => {
        this.setState({
          dealerList: response.data.data.results,
          loading: false,
          count: response.data.data.count,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handlePagination = (e) => {
    this.setState({ offset: e, loading: true }, function () {
      this.getDealersList();
    });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value }, function () {
      this.getDealersList();
    });
  };

  handleDateChange = (e) => {
    this.setState(
      { [e.target.name]: e.target.value, loading: true },
      function () {
        this.getDealersList();
      },
    );
  };

  handleQuickSearch = (e) => {
    e.preventDefault();
    if (
      this.limitInput.current.value === '' ||
      this.limitInput.current.value === '0'
    ) {
      return;
    }
    this.setState(
      { limit: this.limitInput.current.value, offset: 1 },
      function () {
        this.getDealersList();
      },
    );
  };

  handleCountrySelect = (e) => {
    this.setState({ country: e?.value }, function () {
      this.getDealersList();
    });
  };

  handlePagination = (e) => {
    this.setState({ offset: e }, function () {
      this.getDealersList();
    });
  };
  handleOMCChange = (e) => {
    this.setState({ omc_id: e }, function () {
      this.getDealersList();
    });
  };

  resetFilter = () => {
    this.setState(
      {
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        loading: true,
      },
      function () {
        this.getDealersList();
      },
    );
  };

  render() {
    const { dealerList } = this.state;

    const col = [
      {
        name: 'Created date',
        key: 'created_on',
        sortable: true,
        type: 'date',
      },
      {
        name: 'Account id',
        key: 'all',
        formatter: (props) => {
          return <> {props.account_id} </>;
        },
      },
      {
        name: 'Business Name',
        key: 'all',
        formatter: (props) => {
          return <>{props.name}</>;
        },
      },
      {
        name: 'OMC',
        key: 'omc_name',
      },
      {
        name: 'Owner Name',
        key: 'all',
        formatter: (props) => {
          return (
            <>
              {props.dealer_first_name} {props.dealer_last_name}
            </>
          );
        },
      },
      {
        name: 'Email',
        key: 'email',
      },
      {
        name: 'Contact',
        key: 'contact',
      },
      {
        name: 'Country',
        key: 'country',
      },
      {
        name: 'State',
        key: 'state',
      },
      {
        name: 'City',
        key: 'city',
      },
      {
        name: 'Area code',
        key: 'all',
        formatter: (props) => {
          return <>{props.pin_code}</>;
        },
      },
      // {
      //   name: 'Lead source',
      //   key: '',
      // },
      // {
      //   name: 'Subscription status',
      //   key: '',

      // },
    ];

    return (
      <>
        <section
          className={`widget full-width list-table ${this.props.cod ? 'inverted' : ''}`}
        >
          <header>
            <h3> Manage customers </h3>
          </header>
          <main>
            {!this.props.cod && (
              <div className="table-filters">
                <div className="filter-wrapper">
                  <div className="filter-group">
                    <label>User created date:</label>
                    <input
                      className="cstm-date-input"
                      type="date"
                      value={this.state.start_date}
                      name="start_date"
                      onChange={this.handleDateChange}
                    />
                  </div>
                  <div className="filter-group with-icon">
                    <label>Account id:</label>
                    <form onSubmit={this.handleQuickSearch}>
                      <input
                        type="text"
                        value={this.state.account_id}
                        onChange={this.handleChange}
                        name="account_id"
                      />
                      <button
                        type="submit"
                        className="search-icon"
                        onClick={this.handleQuickSearch}
                      />
                    </form>
                  </div>
                  <div className="filter-group with-icon">
                    <label>Business name:</label>
                    <form onSubmit={this.handleQuickSearch}>
                      <input
                        type="text"
                        value={this.state.business_name}
                        onChange={this.handleChange}
                        name="business_name"
                      />
                      <button
                        type="submit"
                        className="search-icon"
                        onClick={this.handleQuickSearch}
                      />
                    </form>
                  </div>
                  <div className="filter-group">
                    <label>OMC:</label>
                    <OMCList
                      handleOMCChange={this.handleOMCChange}
                      value={this.state.omc_id}
                    />
                  </div>
                  <div className="filter-group with-icon">
                    <label>Owner name:</label>
                    <form onSubmit={this.handleQuickSearch}>
                      <input
                        type="text"
                        value={this.state.owner_name}
                        onChange={this.handleChange}
                        name="owner_name"
                      />
                      <button
                        type="submit"
                        className="search-icon"
                        onClick={this.handleQuickSearch}
                      />
                    </form>
                  </div>
                  <div className="filter-group with-icon">
                    <label>Email :</label>
                    <form onSubmit={this.handleQuickSearch}>
                      <input
                        type="text"
                        value={this.state.email}
                        onChange={this.handleChange}
                        name="email"
                      />
                      <button
                        type="submit"
                        className="search-icon"
                        onClick={this.handleQuickSearch}
                      />
                    </form>
                  </div>
                  <div className="filter-group with-icon">
                    <label>Contact:</label>
                    <form onSubmit={this.handleQuickSearch}>
                      <input
                        type="text"
                        value={this.state.contact}
                        onChange={this.handleChange}
                        name="contact"
                      />
                      <button
                        type="submit"
                        className="search-icon"
                        onClick={this.handleQuickSearch}
                      />
                    </form>
                  </div>
                  <div className="filter-group">
                    <label> Country: </label>
                    <CountryList
                      handleCountryChange={this.handleCountrySelect}
                      value={this.state.country}
                    />
                  </div>
                  <div className="filter-group">
                    <label> State: </label>
                    <input
                      type="text"
                      value={this.state.state}
                      onChange={this.handleChange}
                      name="state"
                    />
                  </div>
                  <div className="filter-group">
                    <label> City: </label>
                    <input
                      type="text"
                      value={this.state.city}
                      onChange={this.handleChange}
                      name="city"
                    />
                  </div>
                  {/* <div className="filter-group">
                  <label> Area code: </label>
                  <input
                    type="text"
                    value={this.state.area_code}
                    onChange={this.handleChange}
                    name='area_code'
                  />
                </div>
                <div className="filter-group">
                  <label> Lead source: </label>
                  <input
                    type="text"
                    value={this.state.lead_source}
                    onChange={this.handleChange}
                    name='lead_source'
                  />
                </div> */}
                  <div className="filter-group with-icon">
                    <label>
                      Results to display - (Total: {this.state.count})
                    </label>
                    <form onSubmit={this.handleQuickSearch}>
                      <input type="text" name="limit" ref={this.limitInput} />
                      <button
                        type="submit"
                        className="search-icon"
                        onClick={this.handleQuickSearch}
                      />
                    </form>
                  </div>
                </div>
              </div>
            )}
            <div className="table-wrapper">
              {(() => {
                if (this.state.loading) {
                  return <DropLoaderLarge />;
                } else {
                  return (
                    <>
                      <TableGrid
                        col={col}
                        row={dealerList}
                        offset={this.state.offset}
                        count={this.state.count}
                        limit={this.state.limit}
                        handlePagination={this.handlePagination}
                        enableExport={false}
                        hideActions={true}
                      />
                    </>
                  );
                }
              })()}
            </div>
          </main>
        </section>
      </>
    );
  }
}

export { Users };
